<div class="content-block">
    <div class="dx-card responsive-paddings">
         <h2>Odjava...</h2>
    </div>
</div>